import { combineReducers } from 'redux';

import BookingProjectSettings from '../types/model/BookingProjectSettings';
import DeliveryZone from '../types/model/DeliveryZone';
import Equipment from '../types/model/Equipment';
import EntityName from '../enums/EntityName';
import BlockedSlot from '../types/model/BlockedSlot';

import { generateEntityReducer } from './entity/generateEntityReducer';
import settingsReducer from './settings/reducer';
import authReducer from './auth/reducer';
import globalNotificationsReducer from './global-notifications/reducer';
import notificationsReducer from './notifications/reducer';
import projectReducer from './project/reducer';
import bookingReducer from './bookings/reducer';
import userReducer from './user/reducer';
import usersReducer from './users/reducer';
import subcontractorReducer from './subcontractors/reducer';
import zonesReducer from './zones/reducer';
import barriersReducer from './barriers/reducer';

const rootReducer = combineReducers({
  settings: settingsReducer,
  auth: authReducer,
  globalNotifications: globalNotificationsReducer,
  notifications: notificationsReducer,
  projects: projectReducer,
  bookings: bookingReducer,
  user: userReducer,
  users: usersReducer,
  subcontractor: subcontractorReducer,
  zones: zonesReducer,
  bookingProjectSettings: generateEntityReducer<BookingProjectSettings>(EntityName.BookingProjectSettings),
  deliveryZone: generateEntityReducer<DeliveryZone>(EntityName.DeliveryZone),
  equipment: generateEntityReducer<Equipment>(EntityName.Equipment),
  blockedSlots: generateEntityReducer<BlockedSlot>(EntityName.BlockedSlot),
  barriers: barriersReducer
});

export default rootReducer;
